import { map, Observable } from 'rxjs';

import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input } from '@angular/core';

import { TranslateService } from '@ngx-translate/core';
import { Store } from '@ngxs/store';

import { FadeAnimation } from '@app/core/animations/fade.transition';
import { GlobalFiltersState } from '@app/core/store/states/global-filters/global-filters.state';
import { UserState } from '@app/core/store/states/user/user.state';
import { FilterMode, SelectorTranslationTexts } from '../../models/selector.model';
import { AccountSelectorService } from '../../services/account-selector.service';
import { BaseGlobalSelectorComponent } from '../base-global-selector/base-global-selector.component';

@Component({
  standalone: false,
  selector: 'adspt-account-selector',
  templateUrl: './account-selector.component.html',
  styleUrls: ['./account-selector.component.scss'],
  animations: [FadeAnimation],
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [AccountSelectorService],
})
export class AccountSelectorComponent extends BaseGlobalSelectorComponent {
  @Input() forMainCustomer = false;
  @Input() disableCloseIcon = false;

  readonly isSysAdmin$: Observable<boolean> = this.store.select(UserState.isSysAdmin);

  heapInfo = {
    search: 'account-global-search',
    switch: 'account-global-filter-switch',
    item: 'account-global-select',
    reset: 'account-global-reset-filter',
    apply: 'account-global-apply-filter',
  };
  translations$: Observable<SelectorTranslationTexts> = this.translate.get('global-filter.account-selector').pipe(
    map((values) => ({
      title: values.placeholder,
      search: values.search,
      all: values.all,
      selected: values.selected,
      notSelectable: values['not-selectable'],
      applyTooltip: values['apply-filters-tooltip'],
    })),
  );
  hasSrcQuery$ = this.store.select(GlobalFiltersState.hasAccountQuery);

  onRefinerChange({ filters, query }, tab: FilterMode) {
    const func = tab === FilterMode.Source ? 'onSrcListScrolled$' : 'onDestListScrolled$';
    this.service[func].next(0);
    this.service[tab === FilterMode.Source ? 'srcSub$' : 'destSub$'].next({
      filters: filters,
      query: query,
      forMainCustomer: this.forMainCustomer,
    });
  }

  constructor(
    private store: Store,
    service: AccountSelectorService,
    translate: TranslateService,
    cd: ChangeDetectorRef,
  ) {
    super(service, translate, cd);
  }
}
